export const SEARCH_FIELD_ID = 'browse-search-field-id';
